function Logo({
  className,
  id,
  ref,
}: {
  className?: string;
  id?: string;
  ref?: any;
}) {
  return (
    <svg
      ref={ref}
      className={`logo ${className}`}
      id={id}
      width="209"
      height="61"
      viewBox="0 0 209 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M162.827 23L165.724 5.54545H171.946C173.298 5.54545 174.378 5.79261 175.185 6.28693C175.997 6.78125 176.554 7.45454 176.855 8.30682C177.162 9.15909 177.227 10.1222 177.051 11.196C176.869 12.2699 176.483 13.2358 175.892 14.0938C175.307 14.946 174.526 15.6222 173.548 16.1222C172.571 16.6165 171.409 16.8636 170.062 16.8636H165.776L166.142 14.6307H170.182C171.04 14.6307 171.761 14.483 172.347 14.1875C172.938 13.8864 173.401 13.4773 173.736 12.9602C174.071 12.4375 174.29 11.8494 174.392 11.196C174.5 10.5312 174.472 9.94602 174.307 9.44034C174.142 8.92898 173.815 8.52841 173.327 8.23864C172.844 7.94886 172.168 7.80398 171.298 7.80398H167.991L165.46 23H162.827ZM177.754 23H174.959L184.138 5.54545H187.18L190.564 23H187.768L185.22 8.71591H185.084L177.754 23ZM179.357 16.1648H188.425L188.05 18.3807H178.982L179.357 16.1648ZM192.854 5.54545H195.846L199.102 13.4801H199.298L205.153 5.54545H208.144L200.056 16.1477L198.914 23H196.289L197.423 16.1477L192.854 5.54545Z"
        fill="#3E3635"
      />
      <path
        d="M28.368 56L24.096 35.888H23.904L19.632 56H7.968L0.24 22.976H11.28L15.072 41.696H15.264L19.008 22.976H29.472L33.456 41.696H33.648L37.2 22.976H47.76L40.032 56H28.368ZM51.552 22.976H80.112V30.896H62.16V35.456H77.52V43.04H62.16V48.08H80.448V56H51.552V22.976ZM100.065 22.4C104.289 22.4 107.761 23.264 110.481 24.992C113.201 26.688 114.593 29.216 114.657 32.576V33.152H104.721V32.96C104.721 32 104.369 31.2 103.665 30.56C102.961 29.92 101.889 29.6 100.449 29.6C99.0406 29.6 97.9526 29.808 97.1846 30.224C96.4486 30.64 96.0806 31.152 96.0806 31.76C96.0806 32.624 96.5926 33.264 97.6166 33.68C98.6406 34.096 100.289 34.528 102.561 34.976C105.217 35.52 107.393 36.096 109.089 36.704C110.817 37.28 112.321 38.24 113.601 39.584C114.881 40.928 115.537 42.752 115.569 45.056C115.569 48.96 114.241 51.856 111.585 53.744C108.961 55.632 105.441 56.576 101.025 56.576C95.8726 56.576 91.8566 55.712 88.9766 53.984C86.1286 52.256 84.7046 49.2 84.7046 44.816H94.7366C94.7366 46.48 95.1686 47.6 96.0326 48.176C96.8966 48.72 98.2406 48.992 100.065 48.992C101.409 48.992 102.513 48.848 103.377 48.56C104.273 48.272 104.721 47.68 104.721 46.784C104.721 45.984 104.225 45.392 103.233 45.008C102.273 44.592 100.689 44.16 98.4806 43.712C95.7926 43.136 93.5686 42.544 91.8086 41.936C90.0486 41.296 88.5126 40.256 87.2006 38.816C85.8886 37.376 85.2326 35.424 85.2326 32.96C85.2326 29.344 86.6246 26.688 89.4086 24.992C92.2246 23.264 95.7766 22.4 100.065 22.4ZM136.577 22.4C141.473 22.4 145.345 23.632 148.193 26.096C151.041 28.528 152.465 32.016 152.465 36.56H142.337C142.337 34.64 141.825 33.12 140.801 32C139.809 30.88 138.385 30.32 136.529 30.32C134.385 30.32 132.801 30.992 131.777 32.336C130.785 33.68 130.289 35.552 130.289 37.952V41.024C130.289 43.392 130.785 45.264 131.777 46.64C132.801 47.984 134.353 48.656 136.433 48.656C138.481 48.656 140.033 48.128 141.089 47.072C142.145 46.016 142.673 44.528 142.673 42.608H152.465C152.465 47.12 151.073 50.576 148.289 52.976C145.537 55.376 141.633 56.576 136.577 56.576C130.945 56.576 126.673 55.136 123.761 52.256C120.881 49.376 119.441 45.12 119.441 39.488C119.441 33.856 120.881 29.6 123.761 26.72C126.673 23.84 130.945 22.4 136.577 22.4Z"
        fill="#3E3635"
      />
      <line
        x1="134"
        y1="19"
        x2="134"
        y2="27"
        stroke="#3E3635"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <line
        x1="139"
        y1="27"
        x2="139"
        y2="19"
        stroke="#3E3635"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <line
        x1="134"
        y1="52"
        x2="134"
        y2="60"
        stroke="#3E3635"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <line
        x1="139"
        y1="60"
        x2="139"
        y2="52"
        stroke="#3E3635"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default Logo;
